<template>
  <v-card
    role="region"
    aria-labelledby="cancelled-heading"
    class="pa-4"
  >
    <v-alert
      v-if="hasOrder"
      color="warning"
      type="warning"
      icon="priority_high"
      aria-live="assertive"
      border="left"
      dense
    >
      <h2
        id="cancelled-heading"
        class="sr-only"
      >
        {{ $t("components.checkout.cancelled") }}
      </h2>
      <span>{{ $t("components.checkout.cancelled") }}</span>
    </v-alert>
  </v-card>
</template>

<script>
import links from "@/constants/links";
import { app } from "@/app";

export default {
    name: "CheckoutCancelled",
    data() {
        return {
            order: {}
        }
    },
    computed: {
        hasOrder() {
            return Object.keys(this.order).length > 0;
        },
        points() {
            return this.$store.getters.paymentPrices[this.order.amount];
        }
    },
    beforeMount() {
        this.$api.makeCancelledCheckout(
            this.$route.params.provider,
            this.$route.params.id
        );

        this.$api
            .getOrder(this.$route.params.id)
            .then(order => {
                this.order = order;
            })
            // .then(() => {
            //     this.$ga.ecommerce.addProduct({
            //         id: this.order.id, // Transaction ID. Required.
            //         name: "Cancelled Order", // Product name. Required.
            //         sku: "", // SKU/code.
            //         category: "Zushin points", // Category or variation.
            //         price: this.order.amount, // Unit price.
            //         brand: "Gods of Zushin",
            //         quantity: "1" // Quantity.
            //     });
            // })
            .catch(() => {
                app.then(({ $router }) => {
                    $router.push({
                        path: links.routes.checkout.replace("/:id", "")
                    });
                });
            });
    },
    methods: {}
};
</script>

<style scoped>
.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
</style>
